import React from 'react'
import OnePagerBarChart from '../../../../../../Portfolio_R/SummaryCharts/components/OnePagerBarChart';

const CompositionWalletCard = ({ t, mp }) => {
    return (
        <div className="compositionWallet">
            <div className='bar-chart-title'>
                <h3 className="chart-title">{t('one_pager_report.portfolio_composition')}</h3>
                <p>{t('one_pager_report.approved_amount_projects')}</p>
            </div>

            <div className="content-one-page-barchart">
                {mp.sectors.map((item, index) => {
                    return (
                        <OnePagerBarChart
                            key={index}
                            bgColors={mp.colors(mp.dataSize)[index]}
                            barChartData={item}
                            size={mp.dataSize}
                        />
                    );
                })}
            </div>
        </div>
    )
}

export default CompositionWalletCard